var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "talent-eval-card",
      class: { active: _vm.active, disabled: _vm.disabled },
      style: _vm.cardStyle,
    },
    [
      _vm.$slots.top
        ? _c(
            "div",
            {
              staticClass:
                "standard-size-12 color-gray-7 justify-between flex top",
            },
            [_vm._t("top")],
            2
          )
        : _vm._e(),
      _vm.$slots.title
        ? _c(
            "div",
            {
              staticClass:
                "standard-size-16 ellipsis title font-bolder color-gray-10",
            },
            [_vm._t("title")],
            2
          )
        : _vm._e(),
      _vm.$slots.level
        ? _c(
            "div",
            { staticClass: "standard-size-12 level" },
            [_vm._t("level")],
            2
          )
        : _vm._e(),
      _vm.active
        ? _c("i", { staticClass: "yxt-icon-check font-size-12" })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }